import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StoreModule } from '@ngrx/store';
import { MomentModule } from 'ngx-moment';
import { EffectsModule } from '@ngrx/effects';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';
import { ObjectToKVPPipe } from '@qwyk/ui-standalone';
import { InputNumberModule } from 'primeng/inputnumber';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveValidationModule } from 'angular-reactive-validation';

import { components, MagayaNetworkViewComponent } from './components';
import * as fromMagayaNetworkConfiguration from './+state/magaya-network-configuration.reducer';
import { MagayaNetworkConfigurationFacade } from './+state/magaya-network-configuration.facade';
import { MagayaNetworkConfigurationEffects } from './+state/magaya-network-configuration.effects';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        MomentModule,
        TooltipModule,
        ObjectToKVPPipe,
        InputTextModule,
        TranslateModule,
        InputNumberModule,
        FontAwesomeModule,
        InputTextareaModule,
        ReactiveFormsModule,
        DynamicDialogModule,
        ReactiveValidationModule,
        StoreModule.forFeature(
            fromMagayaNetworkConfiguration.MAGAYANETWORKCONFIGURATION_FEATURE_KEY,
            fromMagayaNetworkConfiguration.reducer
        ),
        EffectsModule.forFeature([MagayaNetworkConfigurationEffects]),
    ],
    declarations: components,
    exports: [MagayaNetworkViewComponent],
    providers: [MagayaNetworkConfigurationFacade],
})
export class HubConsoleOrganizationsMagayaNetworkModule {}
